import { ChatBubble } from '@mui/icons-material'
import { FormControl, Box, FormLabel, Slider, TextField, Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Question } from '../../../models/questionnaire'
import HelpTip from '../startups/HelpTip'

interface Props {
  question: Question
  onAnswerSelection: (answer: number, comment: string | undefined) => void
}

const QuestionnaireQuestion = (props: Props) => {
  const [showComment, setShowComment] = useState(false)
  const [score, setScore] = useState<number | undefined>(undefined)
  const [comment, setComment] = useState<string | undefined>(undefined)
  const [showSliderValue, setShowSliderValue] = useState(false)

  useEffect(() => {
    if (score === undefined) {
      return
    }
    props.onAnswerSelection(score, comment)
  }, [score, comment])

  const marks = [
    {
      label: '🗑',
      value: 0
    },
    {
      label: '🚀',
      value: 1
    }
  ]
  return (
    <Box sx={{ m: 2, marginBottom: '48px', marginTop: '48px' }}>
      <FormControl id={props.question.name} sx={{
        width: '100%'
      }}>
        <Box 
          display='flex' 
          flexDirection='row' 
          alignItems='center'
          sx={{
            marginBottom: '18px'
          }}>
        <FormLabel sx={{
          fontSize: '18px',
          fontWeight: 'bold',
          marginRight: '12px'
        }}>{props.question.displayText}</FormLabel>
        {props.question.displayDescription &&
          <HelpTip tip={props.question.displayDescription!} />
        }
        <Button 
          color='info' 
          aria-selected={showComment} 
          onClick={() => setShowComment(!showComment)} 
          sx={{
            width: '36px',
            height: '36px',
            borderRadius: '18px',
            marginLeft: '12px'
          }}
          variant={showComment ? 'contained' : 'text'}
        >
          <ChatBubble sx={{
            width: '18px',
            m: 0,
            padding: '0px'
          }} />
        </Button>
        </Box>
        <Slider 
          aria-labelledby={props.question.name}
          marks={marks} 
          step={0.1}
          min={0}
          max={1}
          onClick={(event) => {
            setShowSliderValue(true)
          }}
          onChange={(event, value) => {
            setShowSliderValue(true)
            setScore(value as number)
          }}
          sx={{
            width: '80%',
            margin: '12px auto 24px auto',
            '& .MuiSlider-thumb': {
              display: showSliderValue ? 'default' : 'none'
            },
            '& .MuiSlider-track': {
              display: showSliderValue ? 'default' : 'none'
            },
            '& .MuiSlider-markLabel': {
              fontSize: 26
            }
          }}
        />
        {showComment &&
          <TextField 
            onChange={(event) => {
              setComment(event.target.value)
            }}
            multiline 
            maxRows={4} 
            sx={{
              width: '100%',
              marginTop: '12px'
            }} 
          />
        }
      </FormControl>
    </Box>
  )
}

export default QuestionnaireQuestion
